var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-image"},[_c('header-layout'),_c('router-view'),_c('footer-layout',{staticClass:"foot-position"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }